module.exports = __webpack_public_path__ + "static/media/Rectangle 2.1.78ce2d4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Curators/Rectangle 2.1.jpg
// module id = 180
// module chunks = 0